const o = "색상 필드, 현재 색상은 {color}", r = "Color field", l = "Colors palette", e = "색상 프리셋", t = "Custom preset colors", c = "Add color", s = "색상 지우기", C = "Custom color, HEX format", d = "색상을 맞춤 색상 목록에 추가합니다", n = "맞춤 색상 필드 지우기", a = "Delete color with backspace", i = {
  currentColor: o,
  emptyColor: r,
  palette: l,
  presetColors: e,
  customColors: t,
  addColor: c,
  clearColor: s,
  colorField: C,
  colorFieldConfirm: d,
  colorFieldClear: n,
  deleteColorDescriber: a
};
export {
  c as addColor,
  s as clearColor,
  C as colorField,
  n as colorFieldClear,
  d as colorFieldConfirm,
  o as currentColor,
  t as customColors,
  i as default,
  a as deleteColorDescriber,
  r as emptyColor,
  l as palette,
  e as presetColors
};
